import { mutations } from "./mutations";
import { getters } from "./getters";
import { actions } from "./actions";
import { SiteConfigState } from "./state";

const defaultState: SiteConfigState = {
  siteConfigurations: [],
  siteConfigurationsLoaded: false,
  projectTimeZone: "Etc/UTC",
  projectTimeZoneLoaded: false,
  demoMode: false,
};

export const siteConfigModule = {
  state: defaultState,
  mutations,
  actions,
  getters,
};
